/** @module */
import { AbstractConsumerObject } from './abstract-consumer-object';


/**
 * Base class for object derived from Consumer.
 * Should be extended to provide methods for objects.
 * @see {@link abstract-consumer-object.md} for inherited API.
 * @abstract
 */
export class ConsumerObject extends AbstractConsumerObject {}
